if (!customElements.get('marquee-section')) {
  customElements.define(
    'marquee-section',
    class MarqueeSection extends HTMLElement {
      constructor() {
        super();
        this.splide = this.querySelector('.splide');

        this.init();
      }

      init() {
        if (this.splide) {
          new Splide(this.splide, {
            type: 'loop',
            focus: 'center',
            arrows: false,
            pagination: false,
            autoWidth: true,
            gap: 10,
            autoScroll: {
              speed: this.getAttribute('data-speed') || 1,
            },
            breakpoints: {
              990: {
                gap: 10,
              },
            },
          }).mount(window.splide.Extensions);
        }
      }
    }
  );
}
